import { palette } from 'assets/styles/colors';
import colors from '../colors';
import theme from '../radius';

const defaultTextColor = colors.palette.primary.main;

const success = {
  text: palette.cactus[800],
  background: palette.cactus[50],
};

const error = {
  text: palette.pink[800],
  background: palette.pink[50],
};

const filledInfoIconBg = colors.palette.info.main;
const filledInfoTextBg = colors.palette.neutral.main;

const alert = {
  MuiAlert: {
    styleOverrides: {
      root: {
        '&.MuiAlert-root': {
          border: 'none',
          borderRadius: theme.radius.sm,
          display: 'flex',
          overflow: 'hidden',
          padding: 0,

          '.MuiAlert-icon': {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            margin: 0,
            width: '48px',
          },

          '.MuiAlert-message': {
            alignItems: 'center',
            color: defaultTextColor,
            display: 'flex',
            flex: 1,
            fontWeight: 'bold',
            lineHeight: '18px',
            paddingRight: '0.5rem',
          },

          '&.MuiAlert-standardSuccess': {
            background: success.background,
            border: 'none',

            '.MuiAlert-icon': {
              color: success.text,
            },

            '.MuiAlert-message': {
              color: success.text,
            },
          },

          '&.MuiAlert-standardError': {
            background: error.background,

            '.MuiAlert-icon': {
              color: error.text,
            },

            '.MuiAlert-message': {
              color: error.text,
            },
          },

          '&.MuiAlert-filled': {
            '.MuiAlert-filledInfo': {
              backgroundColor: filledInfoIconBg,
            },

            '.MuiAlert-message': {
              backgroundColor: filledInfoTextBg,
              fontWeight: 'normal',
              padding: '0.25rem 0.75rem 0.5rem 0.75rem',
            },
          },
        },
      },
    },
  },
};

export default alert;
